import {APP} from 'jsAssets/constants/app';
import _u from "jsAssets/utils/index";

// initial state
const state = {
    favoriteItems: null,
    favoriteMessages: null,
};

// getters
const getters = {
    favoriteItems: state => state.favoriteItems,
    favoriteMessages: state => state.favoriteMessages,
};

// actions
const actions = {
    addItemToFavorite ({ commit }, productId) {
        let params = {
            'handler': 'favorite_products',
            'func': 'addProductId',
            'productId': productId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setFavoriteItems', responseData.data.data.listProductsId);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    removeFavoriteItem ({ commit }, productId) {
        let params = {
            'handler': 'favorite_products',
            'func': 'removeProductId',
            'productId': productId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setFavoriteItems', responseData.data.data.listProductsId);
            commit('app/setLoadingData', false, { root: true });
        });
    },

};

// mutations
const mutations = {
    setFavoriteItems (state, favoriteItems) {
        state.favoriteItems = favoriteItems;
    },
    setFavoriteMessages (state, favoriteMessages) {
        state.favoriteMessages = favoriteMessages;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
